import {maxCoverIdx} from '../../../../../../constants/FieldConsts';

/* cover */

export function isSetCoverDisabled(field) {
    return field.index > 4 || field.cover;
}

export function setCover(field) {
    const {screen} = field;
    if (!screen.changed) {
        screen.setChanged(true);
    }
    const fields = field.parentCollection.fields;
    for (let i = 0; i < fields.length && i <= maxCoverIdx; i++) {
        if (fields[i].name === field.name) {
            fields[i].setCover(true);
        } else {
            fields[i].setCover(false);
        }
    }
}
